var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 11.8755V17.9265C28.7791 17.6566 26.1847 16.6442 24 15V21.75C23.9996 23.5817 23.4832 25.3762 22.51 26.928C21.5369 28.4798 20.1462 29.7261 18.4975 30.524C16.8487 31.322 15.0086 31.6394 13.1878 31.4398C11.367 31.2402 9.63923 30.5318 8.20246 29.3957C6.76569 28.2596 5.67801 26.7417 5.06404 25.016C4.45007 23.2902 4.33464 21.4264 4.73098 19.6381C5.12732 17.8498 6.0194 16.2094 7.305 14.9046C8.59061 13.5999 10.2177 12.6837 12 12.261V18.75C11.4886 19.1335 11.0838 19.6414 10.8239 20.2254C10.564 20.8094 10.4577 21.4501 10.5152 22.0868C10.5726 22.7234 10.7917 23.3348 11.1519 23.8629C11.5121 24.391 12.0012 24.8182 12.5729 25.1041C13.1447 25.39 13.78 25.5249 14.4186 25.4962C15.0571 25.4675 15.6777 25.276 16.2215 24.9399C16.7652 24.6039 17.2141 24.1344 17.5253 23.5761C17.8366 23.0178 18 22.3892 18 21.75V4.5H24.1245C24.4368 6.3426 25.3146 8.04244 26.6361 9.36394C27.9576 10.6854 29.6574 11.5632 31.5 11.8755Z",
    stroke: "#DEE965",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f31377ccab4185325231bf76aca18bf1.svg";
export { ForwardRef as ReactComponent };